<template>
    <div class="page-wrapper">
        <v-snackbar
                v-model="notification"
                :color="notification_type"
                :timeout="5000"
                :top="true"
        >
            {{ notification_message }}
            <v-btn

                    text
                    @click="notification = false"
            >
                Close
            </v-btn>
        </v-snackbar>

        <v-container
                fill-height
                fluid
                grid-list-xl>
            <v-layout
                    justify-center
                    wrap>
                <v-flex
                        xs12
                        md12
                >
                    <v-data-table
                            :headers="headers"
                            :items="staffs"
                            :server-items-length="totalItems"
                            :page.sync="page"
                            :items-per-page="itemsPerPage"
                            hide-default-footer
                            @page-count="pageCount = $event"
                            sort-by="calories"
                            class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>staffs</v-toolbar-title>
                                <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                ></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog" max-width="500px">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="primary"  class="mb-2" v-on="on">New staffs</v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container grid-list-md>
                                                <v-layout wrap>
                                                    <v-text-field v-model="editedItem.name"
                                                                  required
                                                                  :error-messages="checkName"
                                                                  @input="$v.editedItem.name.$touch()"
                                                                  @blur="$v.editedItem.name.$touch()"
                                                                  label="Name">

                                                    </v-text-field>

                                                    <v-select
                                                            v-model="editedItem.language"
                                                            :items="languages"
                                                            label="Language"
                                                    ></v-select>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.action="{ item }" class="text-center">
                            <v-icon
                                    small
                                    class="mr-2"
                                    @click="editItem(item)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                    small
                                    @click="deleteItem(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                    <div class="text-center pt-2">
                        <v-pagination v-model="page"
                                      :length="pageCount"></v-pagination>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>


<script>
    import {validationMixin} from 'vuelidate'
    import {required, maxLength, minLength, email} from 'vuelidate/lib/validators'

    export default {
        mixins: [validationMixin],

        validations: {
            editedItem:{
                name:{
                    required,
                    maxLength: maxLength(100)
                }
            }
        },
        components: {},
        data() {
            return {
                languages: [
                    'zh',
                    'en'
                ],
                headers: [
                    {
                        text: '#',
                        align: 'left',
                        sortable: false,
                        value: 'id',
                    },
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: false,
                        value: 'name',
                    },
                    {
                        text: 'Language',
                        align: 'left',
                        sortable: false,
                        value: 'language',
                    },
                    {
                        text: 'Actions',
                        align: 'center',
                        sortable: false,
                        value: 'action',
                    },

                ],
                notification_type: 'success',
                notification_message: '',
                notification: false,
                dialog:false,
                staffs: [],
                editedIndex: -1,
                editedItem: {
                    id:0,
                    name: '',
                    language: 'en',
                },
                defaultItem: {
                    id: 0,
                    name: '',
                    language: 'en',
                },
                page: 1, //default load page
                pageCount: 0,
                itemsPerPage: 20, //items shown per page,
                totalItems: 0,
            }
        },
        computed: {
            checkName() {
                const errors = [];
                if (!this.$v.editedItem.name.$dirty) return errors;
                !this.$v.editedItem.name.maxLength && errors.push('.name must be at most 100 characters long');
                !this.$v.editedItem.name.required && errors.push('.name is required.');
                return errors;
            },
            formTitle() {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        },
        created() {
            this.load_staff(this.page);
        },
        methods: {
            load_staff(page_no) {
                let offset = ( page_no - 1) * this.itemsPerPage;
                let limit = this.itemsPerPage;

                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/staff/?limit='+limit+'&offset='+offset).then((response) => {
                    this.staffs = response.data.results;
                    this.notification = false;
                    this.notification_message = '';
                    this.totalItems = (response.data.count / this.itemsPerPage);

                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            editItem(item) {
                this.editedIndex = this.staffs.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                const index = this.staffs.indexOf(item);
                if (confirm('Are you sure you want to delete this item?')) {
                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/staff/' + item.id + '/',{
                            state:4
                        }).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Deleted';
                        this.staffs.splice(index, 1);

                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'Please fill the form out correctly';
                    return false;
                }
                if (this.editedIndex > -1) {
                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/staff/' + this.editedItem.id + '/', this.editedItem).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Saved';
                        Object.assign(this.staffs[this.editedIndex], this.editedItem)
                        this.close()
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });


                } else {
                    this.$http.post(
                        this.$http.defaults.baseURL + '/admin/staff/', this.editedItem).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Saved';
                        this.staffs.push(response.data);
                        this.close();
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }

            },
        },
    }
</script>
